'use strict';

var utils = require('../utils/utils');
var lazyLoad = require('../utils/lazyLoad');
var bodyScrollLock = require('body-scroll-lock');
var debounce = require('lodash/debounce');

/**
 * Update address bar with filters or sorting rules
 *
 * @param {string} url - current url
 * @param {Object} data - additional data
 */
function updateAddressBar(url, data) {
    var query = '';

    if (url.includes('?')) {
        query = url.substring(url.indexOf('?'));
    }

    var historyUrl = window.location.pathname + query;
    var title = $('title').text();
    window.history.pushState(data, title, historyUrl);
}

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    updateDom($results, '.js-refinements');
}

/**
 * Hide filter when no result page is showed
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleGridHeader($results) {
    let $updates = $results.find('.js-refinements');
    let $goHomeButton = $('.js-go-home');

    if (!$updates.length) {
        updateDom($results, '.js-grid-header');
        $goHomeButton.removeClass('d-none');
    } else {
        $goHomeButton.addClass('d-none');
    }
}

/**
 * Updates top custom filter
 * @param {Object} $results - jQuery DOM element
 */
function handleTopCustomFilter($results) {
    var $updates = $results.find('.js-family-filter-wrapper');

    if (!$updates.length) {
        updateDom($results, '.js-family-filter-wrapper');
    }
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.js-refinements': handleRefinements,
        '.js-grid-header': handleGridHeader,
        '.js-top-custom-filter': handleTopCustomFilter
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header__result-count',
        '.js-sort-dropdown',
        '.grid-header__page-title',
        '.js-product-grid',
        '.js-grid-header .sort-order',
        '.show-more',
        '.filter-bar'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

var cache = {
    $refinementBar: $('.js-refinement-bar'),
    $gridHeader: $('.js-grid-header'),
    $isLoadProductsContinously: $('.show-more').length > 0
};

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data('url');
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.append(response);
            $.spinner().stop();
            $('body').trigger('wishlist:updateHearts');
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.js-grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        // update hidden hidden select option
        $('option.' + option.id).val(option.url);
        // update visible dropdown selector option
        $('a.' + option.id).data('value', option.url);
    });
}

function swatchScroll(){
    $('.js-color-swatches').each(function(){
        var productSwatches = $(this);
        var totalSwatches = productSwatches.find('.js-swatch').length;
        var totalDisplay = parseInt($(this).find('.swatch-viewport').attr('data-swatch-display-count'));
        if(totalSwatches > totalDisplay){
            productSwatches.find('.swatch-slide.next').addClass('show');
        };
    });
}

function reviewsHide(){
    setTimeout(function(){
        $('.product-tile').each(function(){
            var product = $(this);
            var review = product.find('div[data-bv-show="inline_rating"]');
            var numReviews = review.find('.bv_numReviews_component_container .bv_text').text();
            if(numReviews != "(0)"){
                review.css('display', 'inline-block');
            }
        });
    }, 300);
}

function getPage(url) {
    $.spinner().start();
    $.ajax({
        url: url,
        data: {selectedUrl: url},
        method: 'GET',
        success: function (response) {
            $('.js-product-grid').empty().html(response);
            lazyLoad.update();
            swatchScroll();
            reviewsHide();
            secondaryImage();
            $('body').trigger('wishlist:updateHearts');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

function truncatePageLinks(currentPage, fromPage){
    if(currentPage == 'all'){
        currentPage = 1;
    };
    $('.paginationBar').each(function(){
        var pageDisplay = 10;

        var paginationBar = $(this);
        var totalProducts = parseInt(paginationBar.attr('data-total-products'));
        var pageSize = parseInt(paginationBar.attr('data-page-size'));
        var pageCount = totalProducts > pageSize ? Math.ceil(totalProducts/pageSize) : null;
        
        if(pageCount > pageDisplay){
            var pageLinks = paginationBar.find('.pageLink');
            var limitDisplay = pageDisplay;
            if(currentPage > 1){
                limitDisplay = parseInt(currentPage) + parseInt((pageDisplay - 2));
            }
            var limitStartDisplay = parseInt(currentPage) - 8;
            if(currentPage <= pageDisplay){
                limitStartDisplay = pageDisplay;
            }
            var endPages = parseInt(pageCount) - parseInt(pageDisplay - 1);
            var previousPage = parseInt(currentPage) - 1;

            var nextPage = currentPage;
            if(currentPage > pageDisplay){
                nextPage = parseInt(currentPage) + 1;
            }

            var currentLink;
            pageLinks.each(function(pageNumber, link){
                pageNumber = pageNumber + 1;
                $(link).addClass('hide');
                if(pageNumber == currentPage){
                    currentLink = $(link);
                }
                if(!fromPage || fromPage < currentPage){
                    //incrementing
                    if(pageNumber <= limitDisplay && pageNumber >= currentPage){
                        $(this).removeClass('hide');
                    }
                    if(pageNumber <= limitDisplay && pageNumber >= endPages){
                        $(this).removeClass('hide');
                    }
                    if(pageNumber == previousPage){
                        $(this).removeClass('hide');
                    }
                }
                if(fromPage && fromPage > currentPage){
                    //decrementing
                    if(pageNumber == currentPage) {
                        $(this).removeClass('hide');
                    }
                    if(currentPage > pageDisplay && pageNumber == nextPage){
                        $(this).removeClass('hide');
                    }
                    if(pageNumber >= limitStartDisplay && pageNumber < currentPage){
                        $(this).removeClass('hide');
                    }
                    if(currentPage <= pageDisplay && pageNumber <= pageDisplay){
                        $(this).removeClass('hide');
                    }
                }
                
            });

            var nextLink = currentLink.next();
            var prevLink = currentLink.prev();

            $('.pageLinkNav').remove();
            var lastAvailableLink = paginationBar.find('.pageLink:not(.hide)').last().attr('data-page-number');
            if(lastAvailableLink < pageCount){
                var nextLinkURL = nextLink.data('url');
                var nextLinkPageNumber = nextLink.data('page-number');
                var pageLinkNext = $('<button class="pageLinkNav next" data-url="'+nextLinkURL+'" data-page-number="'+nextLinkPageNumber+'"></button>');
                $('.paginationPages').append(pageLinkNext);
            }

            var firstAvailableLink = paginationBar.find('.pageLink:not(.hide)').first().attr('data-page-number');
            if(firstAvailableLink >= 2){
                var preLinkURL = prevLink.data('url');
                var prevLinkPageNumber = prevLink.data('page-number');
                var pageLinkPrev = $('<button class="pageLinkNav prev" data-url="'+preLinkURL+'" data-page-number="'+prevLinkPageNumber+'"></button>');
                $('.paginationPages').prepend(pageLinkPrev);
            }

            //show current page in search results
            $('.totalPages').remove();
            var totalPages = $('<span class="totalPages">Page '+currentPage+' of '+pageCount+'</span>');
            paginationBar.append(totalPages);
        }
    });
}

function createPagination(response){
    var paginationBar = $('.paginationBar');

    if(response){
        //updating pagination from filters
        $('.paginationPages').empty();
        var gridFooter = $('.js-grid-footer');
        paginationBar.attr('data-total-products', parseInt(gridFooter.data('count')));
        paginationBar.attr('data-page-size', parseInt(gridFooter.data('page-size')));
        paginationBar.attr('data-show-more-url', gridFooter.find('.show-more button').data('url'));
    }
    
    var totalProducts = parseInt(paginationBar.attr('data-total-products'));
    var pageSize = parseInt(paginationBar.attr('data-page-size'));
    var showMoreURL = paginationBar.attr('data-show-more-url');

    //create page links
    var pageCount;
    if(totalProducts > pageSize){
        pageCount = Math.ceil(totalProducts/pageSize);
        var productStart = 0;
        var url = new URL(showMoreURL);

        //create page links
        for(var i=1; i<=pageCount; i++){
            if(i != 1){
                productStart = productStart + pageSize;
            }
            url.searchParams.set('start', productStart);
            var pageLink = $('<button class="pageLink pageLink-'+i+'" data-url="'+url+'" data-page-number="'+i+'" data-start="'+productStart+'" data-page-size="'+pageSize+'">'+i+'</button>');
            $('.paginationPages').append(pageLink);
        }

        //create view all link
        /*
        url.searchParams.set('start', 0);
        url.searchParams.set('sz', totalProducts);
        $('.pageAll').remove();
        var viewAll = $('<button class="pageAll" data-total-products="'+totalProducts+'" data-url="'+url+'"  data-page-number="all" data-start="0" data-page-size="'+totalProducts+'">View All <span class="count">('+totalProducts+')</span></button>');
        $('.paginationBar').append(viewAll);
        */

        //set current page if params exists
        var urlParams = new URLSearchParams(window.location.search);
        var currentPage = urlParams.get('page');
        $('.pageLink, .pageAll').removeClass('active');
        if(currentPage == 'all'){
            var pageURL = $('.pageAll').data('url');
            $('.pageAll').addClass('active').attr('disabled', 'disabled');
            truncatePageLinks(1);
            getPage(pageURL);
            return false;
        }
        if(currentPage && currentPage <= pageCount && currentPage != 1) {
            var pageURL = $('.pageLink-'+currentPage+'').data('url');
            getPage(pageURL);
        } else {
            currentPage = 1;
        }
        $('.pageLink-'+currentPage+'').addClass('active').attr('disabled', 'disabled');

        truncatePageLinks(currentPage);
    }
}

function secondaryImage(){
    var tileImages = $('.tile-image-wrapper');
    tileImages.each(function(){
        var imageWrapper = $(this);
        var image = $(this).find('.tile-image');
        var secondaryImageSrc = image.attr('data-alt-src');
        var secondaryImageAlt = image.attr('alt');
        var secondaryImageTitle = image.attr('title');
        var secondaryImage = $('<img class="secondary-tile-image" src="'+secondaryImageSrc+'" alt="'+secondaryImageAlt+'" title="'+secondaryImageTitle+'" />');
        imageWrapper.append(secondaryImage);

        imageWrapper.on( "mouseenter", function(){
            secondaryImage.addClass('show');
        }).on( "mouseleave", function(){
            secondaryImage.removeClass('show');
        });

    });
}

function displayMessageAndChangeIcon(data, icon) {
    $.spinner().stop();
    if (data.success) {
        icon.toggleClass('is-filled');
    }
}

module.exports = {
    filter: function () {
        // Display refinements bar when Menu icon clicked
        $('.container').on('click', '.js-btn-filter-results', function () {
            $('.refinement-bar .js-btn-close').trigger('focus');
        });

        $('.grid-header__refinements').on('show.bs.dropdown', function () {
            if (utils.getCurrentLayout() === 'mobile') {
                cache.$gridHeader.css('--flyout-offset-top', cache.$gridHeader[0].getBoundingClientRect().bottom - 1 + 'px');
                bodyScrollLock.disableBodyScroll($('.js-refinements')[0]);
            } else cache.$gridHeader.css('--flyout-offset-top', ''); // clear top value
        }).on('hidden.bs.dropdown', function () {
            bodyScrollLock.clearAllBodyScrollLocks();
        });

        /*
        $('.js-refinement-bar').on('click', '.js-showmore-cta', function (e) {
            e.preventDefault();
            e.stopPropagation();
            $(this).siblings('.collapse').first().collapse('toggle');
        });
        */

        //Collapsible filters
        $('#refine-sidebar').on('click', '.refinement__header', function(){
            $(this).toggleClass('show');
            $(this).siblings('.refinement__body').first().toggleClass('open');
        });
    },

    closeRefinements: function () {
        // Refinements close button
        $('.container').on('click', '.refinement-bar .js-btn-close, .modal-background', function () {
            // $('.refinement-bar, .modal-background').hide();
            $('.js-btn-filter-results').trigger('focus');
        });
    },

    resize: function () {
        // Close refinement bar and hide modal background if user resizes browser
        $(window).resize(function () {
            // $('.refinement-bar, .modal-background').hide();
        });
    },

    sort: function () {
        // Handle sort order menu selection
        $('.container').on('change', '[name=sort-order]', function (e) {
            e.preventDefault();

            $.spinner().start();
            $(this).trigger('search:sort', this.value);

            var url = this.value;
            var data = {
                selectedUrl: { selectedUrl: this.value }
            };

            $.ajax({
                url: url,
                data: data,
                method: 'GET',
                success: function (response) {
                    $('.js-product-grid').empty().html(response);
                    updateAddressBar(url, data);
                    createPagination(response);
                    lazyLoad.update();
                    $.spinner().stop();
                    $('body').trigger('wishlist:updateHearts');
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }).on('click', '.js-sort-dropdown a', function (e) {
            // set actual (but hidden) sort select value, close dropdown and set selected class on dropdown item
            e.preventDefault();
            let $this = $(this);
            $('[name=sort-order]').val($this.data('value')).trigger('change');
            $this.parent().addClass('is-selected').siblings().removeClass('is-selected');
        });
    },

    paginate: function(){
        createPagination();
        
        //pageLink click event
        $('.container').on('click', '.pageLink, .pageAll, .pageLinkNav', function (e) {
            e.stopPropagation();
            e.preventDefault();
            var pageURL = $(this).data('url');
            var urlParams = new URLSearchParams(window.location.search);
            var currentPage = urlParams.get('page');
            var pageNumber = $(this).data('page-number');
            $('html, body').animate({scrollTop:(0)}, 300);

            urlParams.set('page', pageNumber);
            window.history.replaceState({}, '', '?'+urlParams);

            var buttonClass = $(this).hasClass('pageAll')? '.pageAll' : '.pageLink-'+pageNumber;
            $('.pageLink, .pageAll').removeClass('active').removeAttr('disabled');
            $(buttonClass).addClass('active').attr('disabled', 'disabled');

            truncatePageLinks(pageNumber, currentPage);
            getPage(pageURL);
        });
        
    },

    showMore: function () {
        // Show more products
        $('.container').on('click', '.show-more button', function (e) {
            e.stopPropagation();
            var showMoreUrl = $(this).data('url');
            e.preventDefault();

            $.spinner().start();
            $(this).trigger('search:showMore', e);
            $.ajax({
                url: showMoreUrl,
                data: { selectedUrl: showMoreUrl },
                method: 'GET',
                success: function (response) {
                    $('.js-grid-footer').replaceWith(response);
                    updateSortOptions(response);
                    lazyLoad.update();
                    $.spinner().stop();
                    swatchScroll();
                    reviewsHide();
                    $('body').trigger('wishlist:updateHearts');
                    cache.$isLoadProductsContinously = $('.show-more').length > 0;
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    wishlist: function () {
        $('.container').on('click', '.js-wishlist-tile', function (e) {
            e.stopPropagation();
            e.preventDefault();

            const $icon = $(this);
            const heartIsFilledClass = 'is-filled';
            const isPresentInWishList = $icon.hasClass(heartIsFilledClass);
            const $url = isPresentInWishList ? $icon.data('remove-url') : $icon.data('add-url');
            const parent = $icon.closest('.product');
            const pid = parent.attr('data-pid');

            if (!$url || !pid) {
                return;
            }

            $.ajax({
                url: $url,
                type: isPresentInWishList ? 'get' : 'post',
                dataType: 'json',
                data: {
                    pid: pid
                },
                success: function (data) {
                    displayMessageAndChangeIcon(data, $icon);
                    if (isPresentInWishList) {
                        $icon.removeClass(heartIsFilledClass);
                        var wishlistQuantity= $('.js-wishlist-quantity');
                        wishlistQuantity.each(function(){
                            var quantityContainer = $(this);
                            var wishlistCount = parseInt(quantityContainer.text())-1;
                            quantityContainer.text(wishlistCount);
                        });
                    } else {
                        $icon.addClass(heartIsFilledClass);
                        var wishlistQuantity= $('.js-wishlist-quantity');
                        wishlistQuantity.each(function(){
                            var quantityContainer = $(this);
                            var wishlistCount = parseInt(quantityContainer.text())+1;
                            quantityContainer.text(wishlistCount);
                        });
                    }
                },
                error: function (err) {
                    displayMessageAndChangeIcon(err, $icon);
                }
            });
            
        });
    },

    loadProductsContinously: function () {
        /*
        $(window).on('scroll', debounce(function () {
            if (cache.$isLoadProductsContinously) {
                var lastTile = $('.product-grid__tile .js-product').last();
                if (lastTile && lastTile.length > 0) {
                    var result = lastTile.offset().top - $(document).scrollTop();
                    if (result < lastTile.height()) {
                        cache.$isLoadProductsContinously = false;
                        $('.show-more button.more').trigger('click');
                    }
                }
            }
        }, 200));
        */
    },

    applyFilter: function () {
        // Handle refinement value selection and reset click
        $('.container').on(
            'click',
            '.js-refinements li button, .js-family-category, .refinement-bar .js-btn-reset, .js-sidebarReset, .filter-value button, .swatch-filter button',
            function (e) {
                e.preventDefault();

                if (window.handleGAEvent) {
                    window.handleGAEvent(e);
                }
                if (!$(this).hasClass('js-btn-reset')) e.stopPropagation(); // do not skip flyout auto-closing on js-btn-reset click

                var url = $(this).data('href');

                if($(this).hasClass('color-attribute')){
                    var color = $(this).data('color');
                    var urlParams = new URLSearchParams(url);
                    var preferenceNumber;
                    for (var [key, value] of urlParams.entries()){
                        if(value == "refinementColor"){
                            preferenceNumber = key;
                        }
                    }
                    if(preferenceNumber){
                        preferenceNumber = preferenceNumber.replace('prefn', '');
                        var colorParamValue = urlParams.get('prefv'+preferenceNumber);
                        const isLowerCase = str => str === str.toLowerCase();
                        if(isLowerCase(colorParamValue)){
                            color = color.toLowerCase();
                        }
                        colorParamValue = colorParamValue.replace('|', '%7c');
                        url = url.replace('prefv'+preferenceNumber+'='+colorParamValue, 'prefv'+preferenceNumber+'='+color);
                    }
                }

                var data = {
                    page: $('.js-grid-footer').data('page-number'),
                    selectedUrl: url
                };

                $.spinner().start();
                $(this).trigger('search:filter', e);
                $.ajax({
                    url: url,
                    data: data,
                    method: 'GET',
                    success: function (response) {
                        parseResults(response);
                        lazyLoad.update();
                        var refinementBody = $('#refine-dropdown').find('.refinement__body');
                        //refinementBody.removeClass('collapse');
                        updateAddressBar(url, data);
                        //update pageLink URL params
                        cache.$isLoadProductsContinously = $('.show-more').length > 0;
                        createPagination(response);
                        $.spinner().stop();
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        );
    },

    showContentTab: function () {
        // Display content results from the search
        $('.container').on('click', '.content-search', function () {
            if ($('#content-search-results').html() === '') {
                getContent($(this), $('#content-search-results'));
            }
        });

        // Display the next page of content results from the search
        $('.container').on('click', '.show-more-content button', function () {
            getContent($(this), $('#content-search-results'));
            $('.show-more-content').remove();
        });
    },

    swatchView: function(){
        $('.container').on('click', '.js-swatch', function(){
            var swatch = $(this);
            var tile = swatch.closest('.product-tile');
            var productURL = swatch.attr('href');
            var tileImage = tile.find('.tile-image-wrapper');
            var tileLink = tile.find('.pdp-link').find('.link');
            var tileFinalSale = tile.find('.finalSaleContainer');
            var imageURL = swatch.data('swatch-image-url');
            
            if(imageURL) {
                $.spinner().start();
                $.ajax({
                    url: imageURL,
                    method: 'GET',
                    success: function (data) {
                        tileImage.empty();
                        tileImage.attr('href', productURL);
                        tileLink.attr('href', productURL);
                        var images = data.product.images;

                        tileFinalSale.empty();
                        if(data.product.isFinalSale){
                            var finalSaleMessage = $('<div class="finalSale">Final Sale, No Returns Accepted</div>');
                            $(tileFinalSale).append(finalSaleMessage);
                        }

                        if(images){
                            var image = images.medium[0];
                            var secondaryImage = images.medium[1];
                            var htmlImage = "<img src='"+image.srcset.desktop+"' class='tile-image js-tile-image lazy' alt='"+image.alt+"' data-alt-src='"+secondaryImage.url+"' title='"+image.title+"'>";
                            $(htmlImage).appendTo(tileImage);
                            var newImage = tileImage.find('.tile-image');
                            newImage.on('load', function(){
                                var secondaryImageSrc = newImage.attr('data-alt-src');
                                var secondaryImageAlt = newImage.attr('alt');
                                var secondaryImageTitle = newImage.attr('title');
                                var secondaryImage = $('<img class="secondary-tile-image" src="'+secondaryImageSrc+'" alt="'+secondaryImageAlt+'" title="'+secondaryImageTitle+'" />');
                                tileImage.append(secondaryImage);

                                tileImage.on( "mouseenter", function(){
                                    secondaryImage.addClass('show');
                                }).on( "mouseleave", function(){
                                    secondaryImage.removeClass('show');
                                });
                                
                                $(tile).find('.price').replaceWith(data.product.renderedPrice);
                                $(this).addClass('loaded');
                                $.spinner().stop();
                            });
                        }

                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
                return false;
            }
        }); 
    },

    swatchScrollInit: function(){
        swatchScroll();
        $('.container').on('click', '.swatch-slide.next, .swatch-slide.prev', function(){
            var direction = $(this).hasClass('next')? 'next' : 'prev';
            
            var colorSwatches = $(this).parent('.js-color-swatches');
            var swatchViewport = colorSwatches.find('.swatch-viewport');
            var swatchDisplayCount = parseInt(swatchViewport.attr('data-swatch-display-count'));
            var currentPosition = parseInt(swatchViewport.attr('data-slide-position'));
            var newPosition;
            if(direction == 'next'){ newPosition = currentPosition + swatchDisplayCount;}
            if(direction == 'prev') { newPosition = currentPosition - swatchDisplayCount; }
            var endPosition = (newPosition + swatchDisplayCount) - 1;
            var totalSwatchCount = swatchViewport.find('.js-swatch').length;
            swatchViewport.attr('data-slide-position', newPosition);
            
            //hide all swatches
            var swatches = swatchViewport.find('.js-swatch');
            swatches.addClass('hide');

            if(direction == 'next'){
                //show prev button
                colorSwatches.find('.swatch-slide.prev').addClass('show');
                if(endPosition >= totalSwatchCount){
                    //hide next button if end of slide
                    colorSwatches.find('.swatch-slide.next').removeClass('show');
                }
            }

            if(direction == 'prev') {
                if(newPosition == 1){
                    //hide prev button
                    colorSwatches.find('.swatch-slide.prev').removeClass('show');
                }
                if(endPosition <= totalSwatchCount){
                    //show next button
                    colorSwatches.find('.swatch-slide.next').addClass('show');
                }
            }

            //show all swatches between "newPosition" and "endPosition"
            swatches.each(function(i){
                i = i+1;
                if(i >= newPosition && i <= endPosition){
                    $(this).removeClass('hide');
                }
            });
            
        });
    },

    reviewsHideInit: function(){
        reviewsHide();
    },

    secondaryImageInit: function(){
        secondaryImage();
    }
};
